import React from 'react'
import { Popover, makeStyles } from '@material-ui/core';
import styled from 'styled-components';
// import PropTypes from 'prop-types'
const PopUpContainer = styled.div`
  display: grid;
  grid-template-columns: ${({ popUpColumns }) => popUpColumns > 1 ?  '1fr 1fr' : '1fr'};
  /* grid-template-rows: 1fr 1fr 1fr; */
`
const PopUpRow = styled.div`
  display: flex;
  margin: .5em 0;
  flex-direction: column;
  /* &:first-child{
    margin: 0 0 1em
  }
  &:last-child{
    margin: 1em 0 0
  } */
`
const PopUpTitle = styled.div`
  color: #FF6868;
  font-size: 13px;
  line-height: 18px;
  text-transform: uppercase;
`
const PopUpSubtitle = styled.div`
  color: #333333;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: 0.005em;
`
const useStyles = makeStyles((theme) => ({
  popover: {
    pointerEvents: 'none',
  },
  paper: {
    padding: '8px 16px',
    background: '#F9F9F9',
    borderRadius: '5px',
    minWidth: '20em'
  },
}));
const PopContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`

const CustomizePopup = ({ anchorEl, onClose, popContent, open, popUpColumns=1 }) => {
  const classes = useStyles();
  return (
    <Popover
      id="mouse-over-popover"
      className={classes.popover}
      classes={{
        paper: classes.paper,
      }}
      open={open}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      onClose={onClose}
      disableRestoreFocus
    >
      <PopUpContainer popUpColumns={popUpColumns}>
        {
          Object.keys(popContent).map(pc => {
            return (
              <PopUpRow>
                <PopUpTitle>{pc}</PopUpTitle>
                <PopUpSubtitle>{popContent[pc]}</PopUpSubtitle>
              </PopUpRow>
            )
          })
        }
      </PopUpContainer>
    </Popover>
  )
}

CustomizePopup.propTypes = {

}

export default CustomizePopup
